export default __webpack_public_path__ + "static/media/fighter.a75e43a5.jpeg";